export default "__VITE_ASSET__Ctza8fe5__"